
import {useEffect, useState} from "react";

import Loader from "components/Loader";
import { useParams} from "react-router-dom";
import {dispatch, useSelector} from "store";

import Awards from "pages/hr/hr-admin/awards/awards";
import {getList, setApiEndPoint} from "store/reducers/hr/award";

const EmployeeAward = () =>{
    const { employee_id } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const { item } = useSelector((state) => state.employee);

    useEffect(() => {
        dispatch(setApiEndPoint('employee/'+employee_id+'/award'));
        if(loading && employee_id!=item?.id){
            dispatch(getList({search:"",page:1,limit:5}));
        }
            setLoading(true)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employee_id]);


    if (!loading  ) return <Loader />;
    return ( <Awards/>);
}
export default EmployeeAward;
